<div class="layout-wrapper layout-content-navbar">
  <div class="layout-container">
    <aside
      id="layout-menu"
      class="layout-menu menu-vertical menu bg-menu-theme"
      data-bg-class="bg-menu-theme"
      style="
        touch-action: none;
        user-select: none;
        -webkit-user-drag: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      "
    >
      <div class="app-brand demo">
        <a
          [routerLink]="['/dashboard']"
          routerLinkActive="router-link-active"
          class="app-brand-link"
        >
          <span class="app-brand-logo demo">
            <svg
              version="1.0"
              xmlns="http://www.w3.org/2000/svg"
              width="1080.000000pt"
              height="1080.000000pt"
              viewBox="0 0 1080.000000 1080.000000"
              preserveAspectRatio="xMidYMid meet"
            >
              <g
                transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
                fill="#cfcde4"
                stroke="none"
              >
                <path
                  d="M4965 9884 c-414 -41 -823 -140 -1225 -297 -191 -74 -552 -255 -720
-361 -600 -378 -1068 -846 -1446 -1446 -106 -168 -287 -529 -361 -720 -160
-411 -257 -815 -298 -1244 -20 -208 -20 -624 0 -832 41 -429 138 -833 298
-1244 74 -191 255 -552 361 -720 378 -600 846 -1068 1446 -1446 168 -106 529
-287 720 -361 411 -160 815 -257 1244 -298 208 -20 624 -20 832 0 743 71 1458
323 2075 731 181 120 519 383 519 404 0 4 -46 37 -102 73 -221 141 -601 433
-817 627 l-99 88 -88 -64 c-500 -365 -1132 -587 -1747 -612 -573 -24 -1065 77
-1572 322 -662 321 -1180 838 -1501 1501 -245 506 -346 999 -322 1573 29 713
309 1412 786 1963 292 338 632 599 1037 795 506 245 999 346 1573 322 687 -28
1371 -293 1907 -738 362 -299 646 -663 851 -1085 245 -507 346 -999 322 -1572
-13 -333 -79 -655 -199 -978 -51 -137 -200 -443 -268 -550 l-51 -80 53 -49
c177 -166 606 -425 949 -572 l79 -33 33 52 c60 94 128 220 213 392 237 483
386 1011 438 1559 20 208 20 624 0 832 -41 429 -138 833 -298 1244 -74 191
-255 552 -361 720 -378 600 -846 1068 -1446 1446 -168 106 -529 287 -720 361
-411 160 -815 257 -1244 298 -199 19 -656 18 -851 -1z"
                />
                <path
                  d="M5210 6129 c-336 -86 -560 -379 -560 -729 0 -425 325 -750 750 -750
425 0 750 325 750 750 0 352 -226 645 -564 730 -106 27 -272 27 -376 -1z"
                />
              </g>
            </svg>
          </span>
          <span class="app-brand-text demo menu-text fw-bold">QueryAI</span>
        </a>
      </div>

      <div class="menu-inner-shadow"></div>

      <ul class="menu-inner py-1 ps ps--active-y">
        <li class="menu-item" routerLinkActive="active" routerLink="/dashboard">
          <a
            class="menu-link menu-toggle"
            routerLinkActive="active"
            routerLink="/dashboard"
          >
            <i class="menu-icon tf-icons ti ti-dashboard"></i>
            <div>Dashboards</div>
          </a>
        </li>
        <!-- <li class="menu-item" routerLinkActive="active" routerLink="/wizard">
          <a
            class="menu-link menu-toggle"
            routerLinkActive="active"
            routerLink="/wizard"
          >
            <i class="menu-icon tf-icons ti ti-wand"></i>
            <div>Wizard</div>
          </a>
        </li> -->
        <li
          class="menu-item"
          routerLinkActive="active"
          routerLink="/data-generation"
        >
          <a
            routerLinkActive="active"
            routerLink="/data-generation"
            class="menu-link menu-toggle"
          >
            <i class="menu-icon tf-icons ti ti-binary-tree-2"></i>
            <div>Q&amp;A Generation</div>
          </a>
        </li>
        <li class="menu-item" routerLinkActive="active" routerLink="/models">
          <a
            routerLinkActive="active"
            routerLink="/models"
            class="menu-link menu-toggle"
          >
            <i class="menu-icon tf-icons ti ti-hexagons"></i>
            <div>Models</div>
          </a>
        </li>
        <li class="menu-item" routerLinkActive="active" routerLink="/chatbots">
          <a
            routerLinkActive="active"
            routerLink="/chatbots"
            class="menu-link menu-toggle"
          >
            <i class="menu-icon tf-icons ti ti-message-chatbot"></i>
            <div>Chatbots</div>
          </a>
        </li>
        <li class="menu-item" routerLinkActive="active" routerLink="/chats">
          <a
            routerLinkActive="active"
            routerLink="/chats"
            class="menu-link menu-toggle"
          >
            <i class="menu-icon tf-icons ti ti-messages"></i>
            <div>Chats</div>
            <!-- <div class="badge bg-danger rounded-pill ms-auto">5</div> -->
          </a>
        </li>
        <li class="menu-item" routerLinkActive="active" routerLink="/support">
          <a
            routerLinkActive="active"
            routerLink="/support"
            class="menu-link menu-toggle"
          >
            <i class="menu-icon tf-icons ti ti-help"></i>
            <div>Support</div>
          </a>
        </li>
      </ul>
    </aside>

    <div class="layout-page">
      <nav
        class="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
        id="layout-navbar"
      >
        <div
          class="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none"
        >
          <a class="nav-item nav-link px-0 me-xl-4" href="javascript:void(0)">
            <i class="ti ti-menu-2 ti-md"></i>
          </a>
        </div>

        <div
          class="navbar-nav-right d-flex align-items-center"
          id="navbar-collapse"
        >
          <div>{{ tokens }} Available Tokens</div>
          <ul class="navbar-nav flex-row align-items-center ms-auto">
            <!-- Notification -->
            <!-- <li
              class="nav-item dropdown-notifications navbar-dropdown dropdown me-3 me-xl-2"
            >
              <a
                class="nav-link btn btn-text-secondary btn-icon rounded-pill dropdown-toggle hide-arrow waves-effect waves-light"
                href="javascript:void(0);"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <span class="position-relative">
                  <i class="ti ti-bell ti-md"></i>
                  <span
                    class="badge rounded-pill bg-danger badge-dot badge-notifications border"
                  ></span>
                </span>
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-0">
                <li class="dropdown-menu-header border-bottom">
                  <div class="dropdown-header d-flex align-items-center py-3">
                    <h6 class="mb-0 me-auto">Notification</h6>
                    <div class="d-flex align-items-center h6 mb-0">
                      <span class="badge bg-label-primary me-2">8 New</span>
                      <a
                        href="javascript:void(0)"
                        class="btn btn-text-secondary rounded-pill btn-icon dropdown-notifications-all waves-effect waves-light"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        aria-label="Mark all as read"
                        data-bs-original-title="Mark all as read"
                        ><i class="ti ti-mail-opened text-heading"></i
                      ></a>
                    </div>
                  </div>
                </li>
                <li class="dropdown-notifications-list scrollable-container ps">
                  <ul class="list-group list-group-flush">
                    <li
                      class="list-group-item list-group-item-action dropdown-notifications-item waves-effect waves-light"
                    >
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <img
                              src="../../assets/img/avatars/1.png"
                              alt=""
                              class="rounded-circle"
                            />
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="small mb-1">Congratulation Lettie 🎉</h6>
                          <small class="mb-1 d-block text-body"
                            >Won the monthly best seller gold badge</small
                          >
                          <small class="text-muted">1h ago</small>
                        </div>
                        <div
                          class="flex-shrink-0 dropdown-notifications-actions"
                        >
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                            ><span class="badge badge-dot"></span
                          ></a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                            ><span class="ti ti-x"></span
                          ></a>
                        </div>
                      </div>
                    </li>
                    <li
                      class="list-group-item list-group-item-action dropdown-notifications-item waves-effect waves-light"
                    >
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <span
                              class="avatar-initial rounded-circle bg-label-danger"
                              >CF</span
                            >
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">Charles Franklin</h6>
                          <small class="mb-1 d-block text-body"
                            >Accepted your connection</small
                          >
                          <small class="text-muted">12hr ago</small>
                        </div>
                        <div
                          class="flex-shrink-0 dropdown-notifications-actions"
                        >
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                            ><span class="badge badge-dot"></span
                          ></a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                            ><span class="ti ti-x"></span
                          ></a>
                        </div>
                      </div>
                    </li>
                    <li
                      class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read waves-effect waves-light"
                    >
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <img
                              src="../../assets/img/avatars/2.png"
                              alt=""
                              class="rounded-circle"
                            />
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">New Message ✉️</h6>
                          <small class="mb-1 d-block text-body"
                            >You have new message from Natalie</small
                          >
                          <small class="text-muted">1h ago</small>
                        </div>
                        <div
                          class="flex-shrink-0 dropdown-notifications-actions"
                        >
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                            ><span class="badge badge-dot"></span
                          ></a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                            ><span class="ti ti-x"></span
                          ></a>
                        </div>
                      </div>
                    </li>
                    <li
                      class="list-group-item list-group-item-action dropdown-notifications-item waves-effect waves-light"
                    >
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <span
                              class="avatar-initial rounded-circle bg-label-success"
                              ><i class="ti ti-shopping-cart"></i
                            ></span>
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">
                            Whoo! You have new order 🛒
                          </h6>
                          <small class="mb-1 d-block text-body"
                            >ACME Inc. made new order $1,154</small
                          >
                          <small class="text-muted">1 day ago</small>
                        </div>
                        <div
                          class="flex-shrink-0 dropdown-notifications-actions"
                        >
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                            ><span class="badge badge-dot"></span
                          ></a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                            ><span class="ti ti-x"></span
                          ></a>
                        </div>
                      </div>
                    </li>
                    <li
                      class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read waves-effect waves-light"
                    >
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <img
                              src="../../assets/img/avatars/9.png"
                              alt=""
                              class="rounded-circle"
                            />
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">
                            Application has been approved 🚀
                          </h6>
                          <small class="mb-1 d-block text-body"
                            >Your ABC project application has been
                            approved.</small
                          >
                          <small class="text-muted">2 days ago</small>
                        </div>
                        <div
                          class="flex-shrink-0 dropdown-notifications-actions"
                        >
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                            ><span class="badge badge-dot"></span
                          ></a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                            ><span class="ti ti-x"></span
                          ></a>
                        </div>
                      </div>
                    </li>
                    <li
                      class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read waves-effect waves-light"
                    >
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <span
                              class="avatar-initial rounded-circle bg-label-success"
                              ><i class="ti ti-chart-pie"></i
                            ></span>
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">
                            Monthly report is generated
                          </h6>
                          <small class="mb-1 d-block text-body"
                            >July monthly financial report is generated
                          </small>
                          <small class="text-muted">3 days ago</small>
                        </div>
                        <div
                          class="flex-shrink-0 dropdown-notifications-actions"
                        >
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                            ><span class="badge badge-dot"></span
                          ></a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                            ><span class="ti ti-x"></span
                          ></a>
                        </div>
                      </div>
                    </li>
                    <li
                      class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read waves-effect waves-light"
                    >
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <img
                              src="../../assets/img/avatars/5.png"
                              alt=""
                              class="rounded-circle"
                            />
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">Send connection request</h6>
                          <small class="mb-1 d-block text-body"
                            >Peter sent you connection request</small
                          >
                          <small class="text-muted">4 days ago</small>
                        </div>
                        <div
                          class="flex-shrink-0 dropdown-notifications-actions"
                        >
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                            ><span class="badge badge-dot"></span
                          ></a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                            ><span class="ti ti-x"></span
                          ></a>
                        </div>
                      </div>
                    </li>
                    <li
                      class="list-group-item list-group-item-action dropdown-notifications-item waves-effect waves-light"
                    >
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <img
                              src="../../assets/img/avatars/6.png"
                              alt=""
                              class="rounded-circle"
                            />
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">New message from Jane</h6>
                          <small class="mb-1 d-block text-body"
                            >Your have new message from Jane</small
                          >
                          <small class="text-muted">5 days ago</small>
                        </div>
                        <div
                          class="flex-shrink-0 dropdown-notifications-actions"
                        >
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                            ><span class="badge badge-dot"></span
                          ></a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                            ><span class="ti ti-x"></span
                          ></a>
                        </div>
                      </div>
                    </li>
                    <li
                      class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read waves-effect waves-light"
                    >
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <span
                              class="avatar-initial rounded-circle bg-label-warning"
                              ><i class="ti ti-alert-triangle"></i
                            ></span>
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">CPU is running high</h6>
                          <small class="mb-1 d-block text-body"
                            >CPU Utilization Percent is currently at
                            88.63%,</small
                          >
                          <small class="text-muted">5 days ago</small>
                        </div>
                        <div
                          class="flex-shrink-0 dropdown-notifications-actions"
                        >
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                            ><span class="badge badge-dot"></span
                          ></a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                            ><span class="ti ti-x"></span
                          ></a>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div class="ps__rail-x" style="left: 0px; bottom: 0px">
                    <div
                      class="ps__thumb-x"
                      tabindex="0"
                      style="left: 0px; width: 0px"
                    ></div>
                  </div>
                  <div class="ps__rail-y" style="top: 0px; right: 0px">
                    <div
                      class="ps__thumb-y"
                      tabindex="0"
                      style="top: 0px; height: 0px"
                    ></div>
                  </div>
                </li>
                <li class="border-top">
                  <div class="d-grid p-4">
                    <a
                      class="btn btn-primary btn-sm d-flex waves-effect waves-light"
                      href="javascript:void(0);"
                    >
                      <small class="align-middle">View all notifications</small>
                    </a>
                  </div>
                </li>
              </ul>
            </li> -->
            <!--/ Notification -->

            <!-- User -->
            <li class="nav-item navbar-dropdown dropdown-user dropdown">
              <a
                class="nav-link dropdown-toggle hide-arrow p-0"
                href="javascript:void(0);"
                data-bs-toggle="dropdown"
              >
                <div class="avatar avatar-online">
                  <img
                    src="../../assets/img/avatars/1.png"
                    alt=""
                    class="rounded-circle"
                  />
                </div>
              </a>
              <ul class="dropdown-menu dropdown-menu-end">
                <li>
                  <a
                    class="dropdown-item waves-effect"
                    href="https://account.queryai.co.uk/profile"
                    target="_blank"
                  >
                    <i class="ti ti-user me-3 ti-md"></i
                    ><span class="align-middle">Billing & Settings</span>
                  </a>
                </li>
                <li>
                  <a class="dropdown-item waves-effect" routerLink="/usage">
                    <i class="ti ti-chart-histogram me-3 ti-md"></i
                    ><span class="align-middle">Usage</span>
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item waves-effect"
                    href="https://queryai.co.uk/a/subscriptions"
                    target="_blank"
                  >
                    <i class="ti ti-settings me-3 ti-md"></i
                    ><span class="align-middle">Subscriptions</span>
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item waves-effect"
                    href="https://account.queryai.co.uk"
                    target="_blank"
                  >
                    <i class="ti ti-currency-dollar me-3 ti-md"></i
                    ><span class="align-middle">Orders</span>
                  </a>
                </li>
                <li>
                  <div class="d-grid px-2 pt-2 pb-1">
                    <a
                      class="btn btn-sm btn-danger d-flex waves-effect waves-light"
                      href="https://account.queryai.co.uk/profile"
                      target="_blank"
                    >
                      <small class="align-middle">Logout</small>
                      <i class="ti ti-logout ms-2 ti-14px"></i>
                    </a>
                  </div>
                </li>
              </ul>
            </li>
            <!--/ User -->
          </ul>
        </div>
      </nav>
      <router-outlet></router-outlet>
    </div>
  </div>

  <div class="layout-overlay layout-menu-toggle"></div>

  <div
    class="drag-target"
    style="
      touch-action: pan-y;
      user-select: none;
      -webkit-user-drag: none;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    "
  ></div>
</div>
